import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import {HttpClient, HttpEvent, HttpRequest} from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { ReportResponse } from '../../kitchen/shared/domain/report/report-response.model';
import { Observable } from 'rxjs';
import { AdUnitStats } from '../../shared/domain/ad-unit-stats.model';
import {Publisher} from '../../shared/domain/publisher.model';
import {PodcastClip, RSSFeed} from '../../shared/domain/rss.model';

@Injectable()
export class PublisherDashboardService {

  constructor(private httpClient: HttpClient, private route: ActivatedRoute) {
  }

  enrollInPromocast(): Observable<Publisher> {
    return this.httpClient.put<Publisher>(`${environment.serviceUrl}/ad-stats/publisher-stats/enroll-promocast`, null, {
    });
  }

  getPodcastClips(): Observable<PodcastClip[]> {
    return this.httpClient.get<PodcastClip[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/podcast-clips`);
  }

  getRssFeeds(): Observable<RSSFeed[]> {
    return this.httpClient.get<RSSFeed[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/rss-feeds`);
  }

  getLanguageCodes(): Observable<PodcastClip[]> {
    return this.httpClient.get<PodcastClip[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/podcast-clips`);
  }

  createPodcastClip(clip: PodcastClip, audioFile: File, imageFile: File): Observable<PodcastClip[]> {
    const formData = new FormData();
    if (audioFile !== null) {
      formData.append('audio_file', audioFile, audioFile.name);
    }

    if (imageFile !== null) {
      formData.append('image_file', imageFile, imageFile.name);
    }
    formData.append('clip', JSON.stringify(clip));
    return this.httpClient.post<PodcastClip[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/podcast-clip`, formData, {
    });
  }

  updatePodcastClip(clip: PodcastClip, audioFile: File, imageFile: File): Observable<PodcastClip[]> {
    const formData = new FormData();

    if (audioFile !== null) {
      formData.append('audio_file', audioFile, audioFile.name);
    }

    if (imageFile !== null) {
      formData.append('image_file', imageFile, imageFile.name);
    }
    formData.append('clip', JSON.stringify(clip));

    return this.httpClient.put<PodcastClip[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/podcast-clip`, formData, {
    });
  }

  updateFeed(clip: RSSFeed): Observable<RSSFeed[]> {
    return this.httpClient.put<RSSFeed[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/rss-feed`, clip, {
    });
  }

  createFeed(clip: RSSFeed): Observable<RSSFeed[]> {
    return this.httpClient.post<RSSFeed[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/rss-feed`, clip, {
    });
  }

  deletePodcastClip(rssFeed: PodcastClip): Observable<PodcastClip[]> {
    return this.httpClient.delete<PodcastClip[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/podcast-clip/` + rssFeed.id);
  }

  deleteRssFeed(rssFeed: RSSFeed): Observable<RSSFeed[]> {
    return this.httpClient.delete<RSSFeed[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/rss-feed/` + rssFeed.id);
  }

  getDashDataV2(dateFrom: string, dateTo: string): Observable<DashV2ResponseModel> {
    return this.httpClient.post<DashV2ResponseModel>(`${environment.serviceUrl}/ad-stats/publisher-stats/ad-reports/dash-publisher-v2`, null, {
      params: {
        dateFrom,
        dateTo
      }
    });
  }

  adUnitStats(): Observable<AdUnitStats[]> {
    return this.httpClient.post<AdUnitStats[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/ad-reports/adunit-stats`, null);
  }

}

export class DashV2ResponseModel {
  bidders: { urls: DashV2ResponseModelUrl[], impressions?: number, revenue?: number };
  nonBidders: { urls: DashV2ResponseModelUrl[], impressions?: number, revenue?: number };
  vasts: { urls: DashV2ResponseModelUrl[], impressions?: number, revenue?: number };
  impressions?: number;
  revenue?: number;
}

export class DashV2ResponseModelUrl {
  url: string;
  units: DashV2ResponseModelAdUnit[];
  impressions?: number;
  adstxtStatus?: string;
  domainId?: string;
  revenue?: number;
  _expanded?: boolean;
}

export class DashV2ResponseModelAdUnit {
  name: string;
  impressions?: number;
  revenue?: number;
  ext_video: boolean;
}

